// Decorative Murano-inspired silhouettes for color category banners.
// Purely visual: low-opacity SVG line art positioned around the hero.
// Three classic shapes from the universe: mushroom lamp, pendant, chandelier.

export function ColorBannerSilhouettes() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden text-foreground"
    >
      {/* Mushroom lamp — top right */}
      <svg
        viewBox="0 0 200 240"
        className="absolute -right-6 top-6 h-40 w-40 opacity-[0.07] md:-right-4 md:top-10 md:h-64 md:w-64"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
      >
        <path d="M40 90 Q100 10 160 90 Z" />
        <path d="M55 90 Q100 35 145 90" />
        <line x1="95" y1="90" x2="95" y2="180" />
        <line x1="105" y1="90" x2="105" y2="180" />
        <path d="M70 180 Q100 195 130 180 L135 200 Q100 215 65 200 Z" />
      </svg>

      {/* Pendant lamp — left middle, partially clipped */}
      <svg
        viewBox="0 0 160 220"
        className="absolute -left-8 top-24 h-44 w-32 opacity-[0.06] md:left-[6%] md:top-32 md:h-56 md:w-40"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
      >
        <line x1="80" y1="0" x2="80" y2="60" />
        <circle cx="80" cy="65" r="4" />
        <path d="M30 90 Q80 60 130 90 L120 170 Q80 195 40 170 Z" />
        <path d="M40 170 Q80 185 120 170" />
        <path d="M55 100 Q80 88 105 100" opacity="0.6" />
      </svg>

      {/* Chandelier — bottom right, faint */}
      <svg
        viewBox="0 0 240 200"
        className="absolute -bottom-4 right-[8%] hidden h-40 w-48 opacity-[0.05] md:block md:h-52 md:w-64"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.1"
      >
        <line x1="120" y1="0" x2="120" y2="40" />
        <circle cx="120" cy="48" r="6" />
        <path d="M120 54 L60 110 M120 54 L180 110 M120 54 L30 130 M120 54 L210 130 M120 54 L120 150" />
        <circle cx="60" cy="115" r="8" />
        <circle cx="180" cy="115" r="8" />
        <circle cx="30" cy="135" r="7" />
        <circle cx="210" cy="135" r="7" />
        <circle cx="120" cy="155" r="9" />
      </svg>
    </div>
  );
}
